export const RR_STATUS = {
    OK: "OK",
    ERROR: "ERROR"
};